<template>
	<div class="container">
		<!-- 背景图 -->
		<img class="bgone" src="../assets/image/back.jpg" />
		
		<!-- 登录 -->
		<div class="table">
			<p class="login-title">
				用户登录
			</p>
			<div class="user">
				<div id="yonghu" style=""><img src="../assets/image/yhm.png" /></div>
				<input v-model="name" type="text" name="name" placeholder="请输入用户名" autocomplete="off"/>
			</div>			
			<div class="password">
				<div id="yonghu"><img src="../assets/image/mm.png" /></div>
				<input v-model="password" type="password" name="password" placeholder="请输入密码"/>
			</div>

			<div class="btn" @click="doSubmit" style="cursor: pointer;">登录</div>
		</div>
	</div>
</template>
<script>
import main from '../assets/js/main.js';
import js from '../assets/js/jquery-1.8.3.min.js';
import { login } from '../utils/api.js';
export default{
	name:'Login',
	data(){
		return {
			name:'',
			password:''
		}
	},
	methods:{
		doSubmit(){
			if(!this.name) {
				this.$Message.warning('请输入登录账户');
				
				return false;
			}
			
			if(!this.password) {
				this.$Message.warning('请输入登录密码');
		
				return false;
			}
	
			let param = {
				name:this.name,
				password:main.encode(this.password)
			};
			
			login({form:param}).then(res=>{
				res = res || {};
				sessionStorage.setItem('is_login',true);
				sessionStorage.setItem('token',res);
				sessionStorage.setItem('name',this.name);
				this.$router.push('./html').catch(err=>{
					console.log(err);
				});
			})
		}
	},
	mounted(){
		$("input[name=name]").focus(function(){
		  	$("input[name=name]").css("border","1px solid #C2001B");
		});
		
		$("input[name=name]").blur(function(){
		  $("input[name=name]").css("border","1px solid #DDDDDD");
		  $("input[name=name]").css("border-bottom","2px solid #C2001B");
		});
		
		$("input[name=password]").focus(function(){
		  	$("input[name=password]").css("border","1px solid #C2001B");
		});
		
		$("input[name=password]").blur(function(){
		  $("input[name=password]").css("border","1px solid #DDDDDD");
		  $("input[name=password]").css("border-bottom","2px solid #C2001B");
		});
	}
}
</script>

<style scoped>
body{
	margin: 0;
	padding: 0;
}
p{
	padding: 0;
	margin: 0;
};
.*{
    font-family: "微软雅黑";
    font-size: 16px;
    border: 0;
    padding: 0;
    margin: 0;
    color: #666;
    box-sizing:border-box;
    -moz-box-sizing:border-box;
    -webkit-box-sizing:border-box;
}
.bgone{
	width: 100%;
	height: 100%;
	position: absolute;
	top:0;right: 0;left: 0;bottom: 0;margin: auto;
}
.pic{
	width: 492px;
	height: auto;
	position: absolute;
	top:75px;
	right: 453px;
	left: 0;
	bottom: 0;
	margin: auto;
	z-index: 99999;
	transform: scale(0.9);
}
.table{
	background: url(../assets/image/login.jpg);
	width: 960px;
	height: 465px;
	position: absolute;
	top:7%;right: 0;left: 0;bottom: 0;margin: auto;
	border-radius: 4px;
	box-shadow: 4px 4px 10px 1px rgb(51 51 51 / 35%);
    transition: box-shadow .3s;
}
.password{
    width: 330px;
	height: 50px;
	position: absolute;
	left: 550px;
	top: 221px;
}
.code{
    width: 330px;
	height: 50px;
	position: absolute;
	left: 550px;
	top: 221px;
	display: none;
}
.msg-input{
	display: block;
}
.btn{
    position: absolute;
    top: 320px;
    left: 550px;
    border: none;
    color: #fff;
    width: 330px;
	height: 50px;
    text-align: center;
    background-color: #C2001B;
    text-indent: 16px;
    border-radius: 10px;
    font-size:20px ;
    font-weight: 800;
    letter-spacing: 16px;
    border-radius: 4px;
    line-height: 50px;
}

.wel{
	width: 960px;
	height: 35px;
	color: #fff;
    font-size: 30px;
    position: absolute;
    top: -7rem;
    text-align: center;  
   
    
}.wel1{
	width: 960px;
	height: 35px;
	color: #fff;
    font-size: 12.38px;
    position: absolute;
    top: -4rem;
    text-align: center;    
   
}
input{	 
     height: 55px;
     width: 330px;
     text-indent: 55px;
     outline:none;
     background: #FFF;
     border: 1px solid #DDDDDD;
     border-radius: 4px;
     cursor: pointer;
     border-bottom: 2px solid #C2001B;
}
.user{
	width: 330px;
	height: 50px;
	position: absolute;
	left: 550px;
	top: 146px;
}

#yonghu img{
	height: 30px;
	position: absolute;
	left: 10px;
	top: 13px;
}
.tyut-img{
	position: absolute;
	left: 247px;
	top: -80px;
}
.login-title{
	width: 330px;
	height: 36px;
	text-align: right;
	line-height: 36px;
	font-size: 18px;
	color: #C2001B;
	position: absolute;
	left: 550px;
	top: 80px;
	font-weight: bold;
}
.msg-code{
	width: 150px;
	height: 24px;
	position: absolute;
	left: 550px;
    top: 285px;
    font-size: 14px;
    cursor: pointer;
    color: #C2001B;
    text-align: left;
    transition: all 0.5s;
    font-weight: 700;
}
.msg-pwd{
	width: 150px;
	height: 24px;
	position: absolute;
	left: 550px;
    top: 285px;
    font-size: 14px;
    cursor: pointer;
    color: #C2001B;
    text-align: left;
    transition: all 0.5s;
    font-weight: 700;
    display: none;
}
.msg-send{
	width: 150px;
	height: 24px;
	position: absolute;
	left: 730px;
    top: 285px;
    font-size: 14px;
    cursor: pointer;
    color: #666;
    text-align: right;
    transition: all 0.5s;
    font-weight: 700;
    display: none;
    text-decoration: underline;
}
.msg-send-time{
	width: 150px;
	height: 24px;
	position: absolute;
	left: 730px;
    top: 285px;
    font-size: 14px;
    cursor: pointer;
    color: #C2001B;
    text-align: right;
    transition: all 0.5s;
    font-weight: 700;
    display: none;
    text-decoration: underline;
}

</style>


// WEBPACK FOOTER //
// src/views/login.vue